import { Component, ElementRef, Inject, Injector } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from "../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { LastTradeData, lastTradeDataTyped } from '../orderentry/orderentry.component';
import { filter } from 'rxjs/operators';
import { AccountProvider } from '../../../model/workspace.data';


@Component({
    selector: "modal-orderconfirmation",
    template: require('./orderconfirmation.component.html'),
    styles: [require('./orderconfirmation.component.css')]
})

export class OrderConfirmationModal extends AppComponentBase
 {

    constructor(
        injector: Injector,
        protected router: Router,
        protected fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public dataService: DataService
    ) {
        super(injector);
    }


    public ticketToCancel?: string;
    protected _tradeData:TradeRequestModel = new TradeRequestModel();


    protected _lastTradeInformation: LastTradeData | undefined = { qQty: 0, qSize: 0 };
    public get lastTradeInformation (): LastTradeData| undefined  {
        return this._lastTradeInformation;
    }
    public set lastTradeInformation ( value: LastTradeData | undefined  ) {
        this._lastTradeInformation = value;
    }

    
    set tradeData(v:TradeRequestModel)
    {

        if(v.LimitPrice!=0)
        {
            this.limitVisibility = true;
        }

        if(v.StopPrice!=0)
        {
            this.stopVisibility =true;
        }


        if(v.TrailingStopPips!=0)
        {
          this.trailingstopVisibility = true;
        }

        console.log("MODAL");
        console.log(v);
        this._tradeData=v;
    }

    private _trailingstopVisibility: boolean = false;
    public get trailingstopVisibility(): boolean {
        return this._trailingstopVisibility;
    }
    public set trailingstopVisibility(value: boolean) {
        this._trailingstopVisibility = value;
    }





    get tradeData():TradeRequestModel
    {

        return this._tradeData
    }


    protected _stopVisibility:boolean = false;
    set stopVisibility(v:boolean)
    {   
        this._stopVisibility = v;
    }

    get stopVisibility():boolean
    {
        return  this._stopVisibility;
    }

    protected _limitVisibility:boolean = false;
    set limitVisibility(v:boolean)
    {   
        this._limitVisibility = v;
    }

    get limitVisibility():boolean
    {
        return  this._limitVisibility;
    }

    protected _priceVisibility:boolean = true;
    set priceVisibility(v:boolean)
    {   
        this._priceVisibility = v;
    }

    get priceVisibility():boolean
    {
        return  this._priceVisibility;
    }


    get Type():string { return this.tradeData.Type};
    get Currency():string { return this.tradeData.Currency};
    get Quantity():number { return this.tradeData.Quantity};
    get EnterPrice():(number | undefined) { return this.tradeData.EnterPrice};
    get Side(): string { return this.tradeData.Side};
    get StopPrice():number { return this.tradeData.StopPrice};
    get LimitPrice():number { return this.tradeData.LimitPrice};
    get StopPips():number { return this.tradeData.StopPips};
    get LimitPips():number { return this.tradeData.LimitPips};
    get accountId():number | null | undefined { return this.tradeData.AccountId};
    get trailingStopPips():number |undefined {
         return this.tradeData.TrailingStopPips
        };

    set Type(v:string) { };
    set Currency(v:string) { };
    set Quantity(v:number) {  };
    set EnterPrice(v:(number | undefined)) {  };
    set Side(v: string) {  };
    set LimitPrice(v:number) {  };
    set StopPrice(v:number) {  };
    set LimitPips(v:number) {  };
    set StopPips(v:number) {  };
    set trailingStopPips(v:number | undefined) {  };
    set accountId(v:number | null | undefined ){}
    set accountName(v:string | null | undefined){}

    get accountName():string | null | undefined
    {
      //  if(this.accountId)
     //   {
          //  if(this.accountId)

            let v:number = this.accountId?this.accountId:0;
            return this.workspaceService.data.getFullAccountNameById(v);
   //     }
   //     else
  //      {
  //          return "";
  //      }
    }
    

    acceptOrder()
    { 
        this.cancelTrade();
        this.sendTradeRequest();
        this.activeModal.close();
       
    }

    cancelTrade()
    {
        if(this.ticketToCancel == undefined)
            return;

        let ticketData: Ticket = { Ticket: this.ticketToCancel };

        this.dataService.sendRequest({ Cmd: DataService.TYPE_CANCELTRADE, Data: ticketData });
    }
    
    protected _currentRequestId:string="";
    sendTradeRequest():void
    {
       
        
        this._currentRequestId =  "_TRADE_" + this.tradeData.Type + this.tradeData.Side + this.tradeData.Currency + Date.now().toString();

        console.log( this._currentRequestId);  
        console.log(this.tradeData);
        console.log("REQUEST")
        console.log(this.tradeData);
    
       this.tradeData.Id = this._currentRequestId;

      

        if(this.workspace.currentProvider == "OANDA")
        {
            this.tradeData.Provider = this.workspace.currentProvider;
            this.tradeData.AccountID = (this.workspace.accounts as AccountProvider[]).filter(v=>{
                return v.id == this.workspace.activeAccountId
            })[0].accountProviderId;
            
            this.tradeData.AccountId = this.tradeData.AccountID
        }


        if(this.tradeData.TrailingStopPips==0)
        {
            this.tradeData.TrailingStopPips = undefined;
        }

       this.dataService.sendRequest({Cmd: DataService.TYPE_TRADE, Data: this.tradeData});
        
       let selectedSymbolType = this.workspace.boxes.filter(
                                        (v)=>v.Symbol==this.tradeData.Currency
                                    )[0].Type

       
      // this.workspace.lastTradeData
      if(selectedSymbolType=="forex")
      {

        let lastTradeData:lastTradeDataTyped ={};

        lastTradeData[selectedSymbolType] = this.lastTradeInformation

        console.log("[selectedSymbolType, this.lastTradeInformation]");

        this.workspace.lastTradeInformations = JSON.stringify(lastTradeData);
    }

    }

}
